import DateFnsUtils from "@date-io/date-fns";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  withStyles,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

const CustomInputField = ({
  type,
  onChange,
  onBlur,
  style,
  disabled,
  options,
  required,
  value,
  errorMessage,
  fullWidth,
  placeholder,
  maxValue,
  minValue,
  onMouseLeave,
  ...props
}) => {
  const commonProps = {
    type,
    onChange,
    onBlur,
    style,
    disabled,
    options,
    required,
    value,
    errorMessage,
    ...props,
  };
  var field;
  switch (type) {
    case "text":
      field = (
        <>
          <FormLabel>
            {props.label}
            {required && "*"}
          </FormLabel>
          <TextField
            label=""
            error={!!errorMessage}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            value={value}
            variant="outlined"
            size="small"
            placeholder={placeholder}
            inputProps={
              commonProps.capitalize && {
                style: { textTransform: "uppercase" },
              }
            }
          />
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
    case "select":
      field = (
        <>
          <FormLabel>
            {props.label}
            {required && "*"}
          </FormLabel>
          <TextField
            label=""
            error={!!errorMessage}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            value={value}
            variant="outlined"
            placeholder={placeholder}
            size="small"
            select
            inputProps={
              commonProps.capitalize && {
                style: { textTransform: "uppercase" },
              }
            }
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {options.map((_option) => (
              <MenuItem key={_option.value} value={_option.value}>
                {_option.label}
              </MenuItem>
            ))}
          </TextField>
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
    case "radio":
      field = (
        <>
          <FormLabel>
            {props.label}
            {required && "*"}
          </FormLabel>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="Search"
              name="search"
              value={value}
              style={{ flexDirection: "row" }}
              onChange={onChange}
              disabled={disabled}
              onMouseLeave={!!onMouseLeave ? onBlur : null}
            >
              {options.map((_option) => {
                const optionValue = String(_option.value);
                return (
                  <div
                    key={optionValue}
                    className={`investor-radio-button input-margin dual-margin ${
                      value === optionValue ? "investor-active" : ""
                    }`}
                  >
                    <FormControlLabel
                      label={_option.label}
                      value={optionValue}
                      disabled={_option.disabled}
                      control={
                        <Radio
                          className="investor-search-radio"
                          style={{ color: "#033f7c" }}
                        />
                      }
                      className="investor-formcontrol-label"
                      style={{ margin: 0 }}
                    />
                  </div>
                );
              })}
            </RadioGroup>
          </FormControl>
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
    case "checkbox":
      field = (
        <>
          <FormControl fullWidth={fullWidth}>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  {...props}
                  size="medium"
                  onChange={onChange}
                  color="primary"
                />
              }
              // color="blue"
              label={props.label}
            ></FormControlLabel>
          </FormControl>
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
    case "date":
      field = (
        <>
          <FormLabel>
            {props.label}
            {required && "*"}
          </FormLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              InputProps={{ readOnly: true }}
              required
              disableFuture={disabled}
              emptyLabel="Select Date"
              format="dd/MM/yyyy"
              maxDate={
                props.isMinorAllowed
                  ? new Date()
                  : new Date().setFullYear(new Date().getFullYear() - 18)
              }
              onBlur={null}
              inputVariant="outlined"
              value={value || null}
              size="small"
              onChange={onChange}
            />
          </MuiPickersUtilsProvider>
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
    case "slider":
      field = (
        <>
          <div className="d-flex flex-column">
            <FormLabel>
              {props.label}
              {required && "*"}
            </FormLabel>
            <div className="d-flex flex-row">
              <CustomSlider
                max={maxValue}
                min={minValue || 0}
                onChangeCommitted={onChange}
                onChange={onChange}
                disabled={disabled}
                value={value || 0}
                step={1}
                valueLabelDisplay="auto"
                onBlur={onBlur}
                onMouseLeave={onBlur}
              />
              <SmallTextField
                value={value}
                variant="outlined"
                size="small"
                onChange={onChange}
                onKeyDown={onChange}
                disabled={disabled}
                onBlur={onBlur}
              />
            </div>
            <div className="nps-error-message">{errorMessage}</div>
          </div>
        </>
      );
      break;
    default:
      field = (
        <>
          <FormLabel>
            {props.label}
            {required && "*"}
          </FormLabel>
          <TextField
            label=""
            error={!!errorMessage}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            value={value}
            variant="outlined"
            size="small"
            type={type}
            placeholder={placeholder}
            inputProps={{
              autoComplete: "new-password",
            }}
          />
          <div className="nps-error-message">{errorMessage}</div>
        </>
      );
      break;
  }
  return (
    <div
      className={
        "d-flex flex-column input-margin appbar-div-investor-flow dual-margin-investor-flow"
      }
      style={fullWidth ? { gridColumn: fullWidth } : {}}
    >
      {field}
    </div>
  );
};

export default CustomInputField;

const FormLabel = withStyles({
  root: {
    fontSize: "14px",
    fontFamily: "OpenSans-Regular",
    marginLeft: "5px",
    marginBottom: "20px",
    fontWeight: 400,
    color: "#002856",
  },
})(InputLabel);

const CustomSlider = withStyles({
  root: {
    width: 200,
    height: 8,
    marginLeft: "12px",
    marginTop: "10px",
    backgroundColor: "#f5f5f5",
    borderRadius: "5px",
    color: "#033f7c",
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const SmallTextField = withStyles({
  root: {
    fontSize: "14px",
    fontFamily: "OpenSans-Regular",
    marginLeft: "12px",
    marginBottom: "20px",
    marginTop: 8,
    fontWeight: 400,
    color: "#000",
    width: 80,
  },
})(TextField);
